import axios from "axios";
import { Toast } from "../../util/Toast";

import { GET_REPORTED_USER, DISMISS_USER_REPORT } from "./types";

export const getReportedUser = () => (dispatch) => {
  axios
    .get("/report")
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_REPORTED_USER, payload: res.data.report });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const dismissUserReport = (userId) => (dispatch) =>
  axios
    .post("/report/dismiss", { userId })
    .then((res) => {
      if (!res.data.status) {
        Toast("error", res.data.message);
        return false;
      }

      dispatch({ type: DISMISS_USER_REPORT, payload: { userId } });
      return true;
    })
    .catch((error) => {
      Toast("error", error.message);
      return false;
    });
